export default "__VITE_ASSET__Bb70$dY$__"